import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SellerGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}
  canActivate(_route: unknown, state: RouterStateSnapshot): boolean {
    const user = this.authService.getUser();

    if (user && user.isSeller) {
      return true;
    }
    this.router.navigate(['/sellar-login'], {
      queryParams: { redirect: state.url },
    });
    return false;
  }
}
